const Spacer = ({ small = false }: { small?: boolean }) => {
  return <div style={{ height: small ? 8 : 16, width: small ? 8 : 16 }} />
}

export default Spacer
